import $ from 'jquery';

/**
 * site footer
 *
 */

class Footer {
  constructor(element) {
    this.$el = $(element);
    this.smoothscroll();
    // log('Footer : Initialized'); // Removed log package usage
  }

  smoothscroll() {
    $('a[href*=\\#]:not([href=\\#])').on('click',function() {
      if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
        || location.hostname === this.hostname) {

        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          var targetTop = this.hash === '#top' ? 0 : target.offset().top;
          $('html,body').animate({
            scrollTop: targetTop
          }, 1000);
          return false;
        }
      }
    });
  }
}

export default Footer;
